import React, { Fragment, useCallback, useEffect, useState } from "react";
import { Text, View } from "react-native";
import { useQuery } from "@tanstack/react-query";
import { convexQuery } from "@convex-dev/react-query";
import { api } from "../utils/convex-api";
import { Id } from "@teachloop/backend/_generated/dataModel";
import LessonHistorySubjectList from "./lesson-history-subject-list";
import LessonHistoryList from "./lesson-history-list";

function LessonHistory() {
  const { data: lessonHistorySubjects = [] } = useQuery(
    convexQuery(api.student.lessonHistory.queries.getLessonReportSubjects, {})
  );
  const [firstSubject] = lessonHistorySubjects;
  const firstSubjectId = firstSubject?.id;
  const [selectedSubjectId, setSelectedSubjectId] =
    useState<Id<"subjects"> | null>(null);
  const { data: lessonReports = [] } = useQuery(
    convexQuery(
      api.student.lessonHistory.queries.getLessonReports,
      selectedSubjectId
        ? {
            subjectId: selectedSubjectId,
          }
        : "skip"
    )
  );

  useEffect(() => {
    if (firstSubjectId && !selectedSubjectId) {
      setSelectedSubjectId(firstSubjectId);
    }
  }, [firstSubjectId, selectedSubjectId]);

  const renderListHeaderComponent = useCallback(
    () => (
      <View className="mx-5">
        <View className="h-[43px]" />
        <View className="gap-1">
          <Text className="text-[32px] text-gray-800 leading-[1.2] font-medium font-zilla-slab-medium">
            Lesson history
          </Text>
          <Text className="text-xl font-geologica-regular font-normal leading-[1.5] text-gray-800">
            View all previous lesson reports here
          </Text>
        </View>
        <View className="h-8" />
        <LessonHistorySubjectList
          lessonHistorySubjects={lessonHistorySubjects}
          selectedSubjectId={selectedSubjectId}
          setSelectedSubjectId={setSelectedSubjectId}
        />
        <View className="h-4" />
      </View>
    ),
    [lessonHistorySubjects, selectedSubjectId]
  );

  return (
    <Fragment>
      <LessonHistoryList
        lessonReports={lessonReports}
        ListHeaderComponent={renderListHeaderComponent}
      />
    </Fragment>
  );
}

export default LessonHistory;
